export enum DeviceStatuses {
  Online = "ONLINE",
  Offline = "OFFLINE",
}

export interface DeviceStatusProps {
  status: DeviceStatuses | string;
}
